import { IUser, RegionsResponse } from '@novakid/ts-types';
import { HTTPTransport } from '@novakid/frontend-core';

import { CONFIG } from 'config';

export const HEADER_KEY = 'x-novakid-auth';
export const transport = new HTTPTransport(CONFIG.API_URL);
const transportGroup = new HTTPTransport(CONFIG.GROUP_CLASSROOM_API_URL);

export const getUser = (userId: number, token: string) => {
  return transport.get<IUser>(`users/${userId}`, {
    headers: { [HEADER_KEY]: token },
    tries: 3,
  });
};

export const getRegions = () => {
  return transport.get<RegionsResponse>('regions').then((response) => response._embedded.regions);
};

export const logout = (token: string) =>
  transport.post('auth/logout', {
    headers: { [HEADER_KEY]: token },
  });

export const getClassroom = (
  userId: number,
  authToken: string,
  classId: number | string,
  isObserver: boolean
) => {
  const urlPart = isObserver ? 'admin_resources' : `users/${userId}`;

  return transport.get<{
    meta_data: {
      is_unified_group_classroom?: boolean;
      unified_classroom?: boolean;
      is_old_ui?: boolean;
    };
  }>(`${urlPart}/classes/${classId}`, {
    headers: { [HEADER_KEY]: authToken },
    tries: 5,
  });
};

export const getReservation = (userId: number, authToken: string, reservationId: string) => {
  return transportGroup.get<{ class_id: number }>(`user/${userId}/reservations/${reservationId}/`, {
    headers: { [HEADER_KEY]: authToken },
    tries: 5,
  });
};

export const getGroupClassroom = (
  teacherId: number,
  authToken: string,
  groupClassId: string,
  isObserver?: boolean
) => {
  const urlPart = isObserver ? '' : `teacher/${teacherId}/`;

  return transportGroup.get<{ participants: { class_id: number }[] }>(
    urlPart + `group-classes/${groupClassId}/`,
    {
      headers: { [HEADER_KEY]: authToken },
      tries: 5,
    }
  );
};
